import { Accordion, Button, Container, Group, Paper, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { MARKETING_FAQ_IDS } from '#marketing/lib/marketing-capabilities.js';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';
import { MarketingSection } from './MarketingSection.jsx';

/**
 * Public /faq page.
 */
export function MarketingFaqPage() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();

  const items = MARKETING_FAQ_IDS.map((id) => ({
    value: id,
    question: t(`marketing.faq.items.${id}.question`),
    answer: t(`marketing.faq.items.${id}.answer`),
  }));

  return (
    <Container size="md" py="xl">
      <MarketingSection
        titleKey="marketing.faq.heroTitle"
        descriptionKey="marketing.faq.heroDescription"
      />

      <Accordion variant="separated" mb="xl">
        {items.map((item) => (
          <Accordion.Item key={item.value} value={item.value}>
            <Accordion.Control>{item.question}</Accordion.Control>
            <Accordion.Panel>{item.answer}</Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>

      <Paper withBorder radius="md" p="xl" ta="center">
        <Text fw={700} size="lg" mb="lg">
          {t('marketing.faq.ctaTitle')}
        </Text>
        <Group justify="center">
          <Button component={Link} to={localePath(locale, '/contact')} color="pachubColourScheme">
            {t('marketing.faq.ctaButton')}
          </Button>
        </Group>
      </Paper>
    </Container>
  );
}
